/** Unit-of-measure options for Price Amount, based on Pricing Model (Pricing & Commercial). */

/** Per Piece (Unit Price) — default when no dimension units from master API */
export const PRICE_UOM_PER_PIECE_OPTIONS = [
  { value: 'nos', label: 'Nos' },
  { value: 'kg', label: 'Kg' },
  { value: 'ton', label: 'Ton' },
  { value: 'ltr', label: 'Ltr' },
  { value: 'mtr', label: 'Mtr' },
];

/** Per Batch / Lot */
export const PRICE_UOM_BATCH_LOT_OPTIONS = [
  { value: 'batch', label: 'Batch' },
  { value: 'lot', label: 'Lot' },
];

/** Per Hour (Machine / Labour) */
export const PRICE_UOM_PER_HOUR_OPTIONS = [
  { value: 'machine_hour', label: 'Machine Hour' },
  { value: 'labour_hour', label: 'Labour Hour' },
  { value: 'line_hour', label: 'Line Hour' },
];

/** Per Day / Per Shift */
export const PRICE_UOM_PER_DAY_SHIFT_OPTIONS = [
  { value: 'day', label: 'Day' },
  { value: 'shift', label: 'Shift' },
];

/** Monthly Lease / Retainer, Cost + BOM, Fixed project Fee */
export const PRICE_UOM_PROJECT_OPTIONS = [
  { value: 'pcs', label: 'PCS' },
  { value: 'set', label: 'Set' },
  { value: 'pair', label: 'Pair' },
  { value: 'kg', label: 'Kg' },
  { value: 'g', label: 'g' },
  { value: 'ton', label: 'ton' },
  { value: 'mm', label: 'mm' },
  { value: 'sq_m', label: 'sq.m' },
];

/** Monthly Lease / Retainer only */
export const PRICE_UOM_MONTHLY_LEASE_OPTIONS = [
  { value: 'per_week', label: 'Per Week' },
  { value: 'per_month', label: 'Per Month' },
];

/**
 * Resolve UOM dropdown options for Price Amount from selected pricing model.
 * Falls back to dimension-unit master list for per-piece when available.
 */
export const getPriceUomOptions = (pricingModel, dimensionUnitOptions = []) => {
  switch (pricingModel) {
    case 'per_batch_lot':
      return PRICE_UOM_BATCH_LOT_OPTIONS;
    case 'per_hour_machine_labour':
      return PRICE_UOM_PER_HOUR_OPTIONS;
    case 'per_day_per_shift':
      return PRICE_UOM_PER_DAY_SHIFT_OPTIONS;
    case 'monthly_lease_retainer':
      return PRICE_UOM_MONTHLY_LEASE_OPTIONS;
    case 'cost_bom_pass_through_markup':
    case 'fixed_project_fee':
      return PRICE_UOM_PROJECT_OPTIONS;
    case 'per_piece_unit_price':
    default:
      if (Array.isArray(dimensionUnitOptions) && dimensionUnitOptions.length > 0) {
        return dimensionUnitOptions;
      }
      return PRICE_UOM_PER_PIECE_OPTIONS;
  }
};

export const PRICE_UOM_VALUE_TO_LABEL = Object.fromEntries(
  [
    ...PRICE_UOM_PER_PIECE_OPTIONS,
    ...PRICE_UOM_BATCH_LOT_OPTIONS,
    ...PRICE_UOM_PER_HOUR_OPTIONS,
    ...PRICE_UOM_PER_DAY_SHIFT_OPTIONS,
    ...PRICE_UOM_PROJECT_OPTIONS,
    ...PRICE_UOM_MONTHLY_LEASE_OPTIONS,
  ].map(({ value, label }) => [value, label]),
);

export const priceUomToLabel = (value) => PRICE_UOM_VALUE_TO_LABEL[String(value || '').trim()] || String(value || '');
